import styles from './Button.module.css';
import { ButtonProps } from './ButtonProps';
import classNames from '../../utils/classNames';
import LoadingSpinner from '../../atoms/loading-spinner';
import { forwardRef } from 'react';

const ButtonNew = forwardRef<HTMLButtonElement, ButtonProps>(({
    className,
    value,
    children,
    disabled = false,
    fullWidth = false,
    spaceBetween = false,
    iconBefore,
    iconAfter,
    type = 'button',
    size = 'lg',
    variant = 'primary',
    loading = false,
    inline = false,
    selected = false,
    testName = 'button',
    noTabIndex = false,
    iconOnly = false,
    onClick,
    onMouseDown,
    onKeyDown,
}: ButtonProps, ref) => {
    const hasIconBeforeClassName = () => {
        return (iconBefore !== undefined) ? styles.hasIconBefore : '';
    }

    const hasIconAfterClassName = () => {
        return (iconAfter !== undefined) ? styles.hasIconAfter : '';
    }

    const mainClassNames = () => {
        return classNames(
            className ?? className,
            styles.button,
            inline && styles.inline,
            fullWidth && styles.fullWidth,
            spaceBetween && styles.spaceBetween,
            styles[size],
            variant && styles[variant],
            loading ? styles.loading : '',
            selected && styles.selected,
            hasIconBeforeClassName(),
            hasIconAfterClassName(),
            (iconOnly || (iconBefore !== undefined && children == undefined)) ? styles.iconOnly : '',
        );
    }

    return (
        <button
            ref={ref}
            className={mainClassNames()}
            data-testid={testName}
            disabled={disabled}
            type={type}
            value={value}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onKeyDown={onKeyDown}
            tabIndex={noTabIndex ? -1 : 0}
        >
            {iconBefore &&
                <span className={classNames(styles.iconBefore)}>{iconBefore}</span>
            }
            {children}
            {iconAfter &&
                <span className={classNames(styles.iconAfter)}>{iconAfter}</span>
            }
            {loading &&
                <LoadingSpinner className={styles.spinner}/>
            }
        </button>
    )
});

ButtonNew.displayName = 'ButtonNew';

export default ButtonNew;
